module.exports = __webpack_public_path__ + "static/Blob3-357f0c225a553e54f9f2e163262e719c.png";